import { createContext, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The Visualizer studio's preview canvas, for the settings that draw their own.
 *
 * Settings sit on the left and what they change on the right. Some sections
 * already own an interactive preview — the product card you drop fields onto,
 * the button you click to rename — and that preview shares state (and a drag
 * context) with the controls beside it. Portalling it keeps one component and
 * one state while the preview renders in the canvas.
 *
 * Outside the studio there is no canvas, and the preview renders in place.
 */
const StudioCanvasContext = createContext<HTMLElement | null>(null);

export const StudioCanvasProvider = StudioCanvasContext.Provider;

/** Whether this subtree is rendered inside the studio's settings panel. */
export const useInStudio = () => useContext(StudioCanvasContext) !== null;

export const CanvasPortal = ({ children }: { children: ReactNode }) => {
    const canvas = useContext(StudioCanvasContext);
    return canvas ? createPortal(children, canvas) : <>{children}</>;
};
